module.exports = __webpack_public_path__ + "img/tree-01-d-trunk.6b842ec6.png";